angular.module('tf.directives')

    .directive('sideTemplatesMenu', ['ThumbnailSequence','$timeout','$rootScope', function (ThumbnailSequence, $timeout, $rootScope) {
        return{
            restrict:'E',
            replace:true,
            scope:{
                templates : "=?",
                canProduce : "=?",
                selected : "=?"
            },
            templateUrl:'js/components/sideTemplatesMenu/sideTemplatesMenu.html',
            link: function(scope,element,attr){

                //scope.isOpen = false;
                scope.selectTemplate = function(template){
                    event.stopPropagation();
                    scope.selected = template;
                    for(var i = 0 ; i < scope.templates.length ; i++){
                        scope.templates[i].isSelected = false;
                    }
                    template.isSelected = true;

                    scope.selected.thumbnail = template.thumbnail;
                    if(!scope.selected.thumbnailSequence){
                        scope.selected.thumbnailSequence = new ThumbnailSequence();
                    }
                    scope.isOpen = false;
                };
                scope.toggleTemplateUse = function(template){
                    event.stopPropagation();
                    template.use = !template.use;
                    var counter =0;
                    for(var i = 0 ; i < scope.templates.length ; i++){
                        if(scope.templates[i].use  && !scope.templates[i].hide){
                            counter++;
                        }
                    }
                    scope.canProduce = counter > 0;
                };

                function toggleTemplateSelector(open){
                    if(open !== undefined){
                        scope.isOpen = open;
                    } else {
                        scope.isOpen = !scope.isOpen;
                    }
                    try{
                        if($rootScope.sidepanel.isOpen()){
                            $rootScope.sidepanel.close();
                        }
                    } catch(err){}
                    return scope.isOpen;
                }
                function isSingleTemplate(){
                    return scope.templates.length === 1;
                }
                function isOpen(){
                    return scope.isOpen;
                }
                function open(){
                    scope.isOpen = true;
                }
                function close(){
                    scope.isOpen = false;
                }
                $(window).click(function() {
                    if (scope.isOpen) {
                        scope.isOpen = false;
                        scope.$apply();
                    }
                });

                $rootScope.templateSelector = {
                    toggle              :  toggleTemplateSelector,
                    isSingleTemplate    : isSingleTemplate,
                    isOpen              : isOpen,
                    open                : open,
                    close               : close
                };
            }
        };
    }]);